var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c(
                    "div",
                    { staticClass: "left-bar" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("品种客户数量统计分析"),
                      ]),
                      _c("DatePicker", {
                        staticStyle: { "margin-left": "4px", width: "200px" },
                        attrs: {
                          type: "daterange",
                          size: "small",
                          transfer: "",
                          placement: "bottom-end",
                          placeholder: "选择期初和期末时间",
                        },
                        on: { "on-change": _vm.onDateChange },
                        model: {
                          value: _vm.selectDates,
                          callback: function ($$v) {
                            _vm.selectDates = $$v
                          },
                          expression: "selectDates",
                        },
                      }),
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "200px", "margin-left": "5px" },
                          attrs: { size: "small", placeholder: "选择大类" },
                          model: {
                            value: _vm.productMainCategoryUuid,
                            callback: function ($$v) {
                              _vm.productMainCategoryUuid = $$v
                            },
                            expression: "productMainCategoryUuid",
                          },
                        },
                        _vm._l(_vm.mainCategorySource, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.mainCategoryUuid,
                              attrs: { value: item.mainCategoryUuid },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t   \t\t" +
                                  _vm._s(item.mainCategoryName)
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "200px", "margin-left": "5px" },
                          attrs: { size: "small", placeholder: "选择小类" },
                          model: {
                            value: _vm.productSubCategoryUuid,
                            callback: function ($$v) {
                              _vm.productSubCategoryUuid = $$v
                            },
                            expression: "productSubCategoryUuid",
                          },
                        },
                        _vm._l(_vm.subCategorySource, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.subCategoryUuid,
                              attrs: { value: item.subCategoryUuid },
                            },
                            [_vm._v(_vm._s(item.subCategoryName))]
                          )
                        }),
                        1
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "success",
                            size: "small",
                            icon: "ios-stats",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.beginStat()
                            },
                          },
                        },
                        [_vm._v("统计")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("Table", {
                    ref: "mainTable",
                    attrs: {
                      columns: _vm.mainTable.columns,
                      size: "small",
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      height: _vm.mainTable.tableHeight,
                      stripe: "",
                      border: "",
                    },
                  }),
                  _c(
                    "Modal",
                    {
                      attrs: { width: 1000, "footer-hide": "" },
                      model: {
                        value: _vm.customerProductQantityModal.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.customerProductQantityModal, "show", $$v)
                        },
                        expression: "customerProductQantityModal.show",
                      },
                    },
                    [
                      _vm.customerProductQantityModal.innerSpin
                        ? _c("Spin", { attrs: { size: "large", fix: "" } })
                        : _vm._e(),
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "font-size": "14px",
                            },
                          },
                          [_vm._v("品种客户数量统计")]
                        ),
                      ]),
                      _c("CustomerStatBar", {
                        ref: "customerStatBar",
                        staticStyle: { height: "400px", width: "100%" },
                        attrs: {
                          value: _vm.customerProductQantityModal.barData,
                          text: _vm.customerProductQantityModal.barTitle,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }